const MIN_PRETTY_PHONE_DIGITS = 10;
const LOCAL_PHONE_DIGIT_COUNT = 9;
const EMPTY_PHONE_LABEL = "-";

const toPhoneDigits = (phoneNumber: string | null): string => {
  return (phoneNumber ?? "").replace(/\D/g, "");
};

const formatPrettyPhoneDigits = (
  countryCode: string,
  localNumber: string,
): string => {
  const prefix = localNumber.slice(0, 2);
  const middle = localNumber.slice(2, 5);
  const suffixFirst = localNumber.slice(5, 7);
  const suffixSecond = localNumber.slice(7, 9);

  return `+${countryCode} ${prefix} ${middle} ${suffixFirst} ${suffixSecond}`;
};

/**
 * Formats a phone number for staff views.
 * Preferred output: +46 70 123 45 67. Falls back to +digits when shape is unknown.
 */
export const formatStaffPhoneNumber = (phoneNumber: string | null): string => {
  const digits = toPhoneDigits(phoneNumber);
  if (digits.length === 0) return EMPTY_PHONE_LABEL;
  if (digits.length < MIN_PRETTY_PHONE_DIGITS) return `+${digits}`;

  const countryCode = digits.slice(0, -LOCAL_PHONE_DIGIT_COUNT);
  const localNumber = digits.slice(-LOCAL_PHONE_DIGIT_COUNT);
  if (countryCode.length === 0) return `+${digits}`;

  return formatPrettyPhoneDigits(countryCode, localNumber);
};
